//import Pusher from "pusher-js";

// console.log("KEY", process.env.VUE_APP_PUSHER_APP_KEY);

/*
Pusher.logToConsole = false;
var azurePusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  forceTLS: true,
  encrypted: true
});
*/

export function subscribe(dominio, evento, callback) {
    //console.log("Channel: " + dominio, "Event: " + evento);

    window.Echo.leaveChannel(dominio);

    window.Echo.channel(dominio).listen("." + evento, e => {
        if (callback) callback(e);
    });

    return true;
}

export function unSubscribe(dominio, evento) {
    //console.log("Unsubscribe: " + dominio, "Event: " + evento);

    window.Echo.leaveChannel(dominio);

    window.Echo.channel(dominio).stopListening("." + evento);

    return true;
}
